export const get = (url, params, fetchArgs) =>
{
    const queryString = getQueryString(params);
    let outUrl = url;
    if (queryString !== '') outUrl += '?' + queryString;

    if (outUrl.length > 1000)
        return post(url, params, fetchArgs);
    else
        return fetch(outUrl, fetchArgs).then(response => response.json());
};

export const post = (url, params, fetchArgs = {}) =>
{
    return fetch(url,
        {
            ...fetchArgs,
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent for details on + etc.
            body: getQueryString(params)
                .replace(/%20/g, '+')
                .replace(/[!'()*]/g, (c) =>
                {
                    return '%' + c.charCodeAt(0).toString(16);
                })
        })
        .then(response => response.json());
};

const getQueryString = params =>
{
    let arrQuery = [];
    if (params !== undefined)
    {
        arrQuery = Object.keys(params).reduce((filtered, key) =>
        {
            if (params[key] !== undefined) filtered.push(key + '=' + encodeURIComponent(params[key]));
            return filtered;
        }, []);
    }
    return arrQuery.join('&');
};